import { gql } from '@apollo/client';
import React from 'react';
import classNames from 'classnames';
import { DesktopSiteNavPulldownFragment } from '../../generated/types/DesktopSiteNavPulldownFragment';
import {
  DESKTOP_SITE_NAV_LIST_COLUMN_FRAGMENT,
  DesktopSiteNavListColumn
} from './DesktopSiteNavListColumn';
import {
  DESKTOP_SITE_NAV_IMAGE_COLUMN_FRAGMENT,
  DesktopSiteNavImageColumn
} from './DesktopSiteNavImageColumn';
import './DesktopSiteNavPulldown.scss';

export const DESKTOP_SITE_NAV_PULLDOWN_FRAGMENT = gql`
  fragment DesktopSiteNavPulldownFragment on NavItem {
    desktopChildren {
      ...DesktopSiteNavListColumnFragment
      ...DesktopSiteNavImageColumnFragment
    }
  }
  ${DESKTOP_SITE_NAV_LIST_COLUMN_FRAGMENT}
  ${DESKTOP_SITE_NAV_IMAGE_COLUMN_FRAGMENT}
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  navItem: DesktopSiteNavPulldownFragment;
  active: boolean;
}

export const DesktopSiteNavPulldown: React.FC<Props> = ({ className, navItem, active }) => (
  <div className={classNames('DesktopSiteNavPulldown', className)}>
    {navItem.desktopChildren.map((column, index) => {
      switch (column.__typename) {
        case 'NavListColumn':
          return (
            <DesktopSiteNavListColumn
              key={index}
              className="DesktopSiteNavPulldown__column"
              navListColumn={column}
            />
          );

        case 'NavImageColumn':
          return (
            <DesktopSiteNavImageColumn
              key={index}
              className="DesktopSiteNavPulldown__column"
              navImageColumn={column}
              active={active}
            />
          );
      }
    })}
  </div>
);
